// pages/_app.js
import Console from "layout/Console";
import "styles/globals.scss";

export default function App({ Component, pageProps }) {


  return (
    <div className="app">
      <Console>
        <Component {...pageProps} />
      </Console>
    </div>
  );
}
